import { render } from "./NotificationsSubscribers.vue?vue&type=template&id=d66ca95c"
import script from "./NotificationsSubscribers.vue?vue&type=script&lang=js"
export * from "./NotificationsSubscribers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__